import React from 'react';
import { FadeIn } from './FadeIn';
export function Guarantee() {
  return <section className="bg-azul-noche py-24 px-6 text-white" data-id="element-194">
      <div className="max-w-3xl mx-auto text-center" data-id="element-195">
        <FadeIn data-id="element-196">
          <div className="flex justify-center mb-8" data-id="element-197">
            <svg width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#C9B8E8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-198">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-199" />
              <path d="m9 12 2 2 4-4" data-id="element-200" />
            </svg>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 font-serif" data-id="element-202">
            Sin riesgo. Sin preguntas. Sin letra pequeña.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-203">
          <div className="bg-white text-texto p-8 md:p-10 rounded-2xl mt-10 shadow-2xl relative" data-id="element-204">
            <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-lila-suave text-azul-noche font-bold px-6 py-2 rounded-full shadow-md whitespace-nowrap" data-id="element-205">
              Garantía de 30 Días
            </div>
            <h3 className="text-2xl font-bold text-azul-noche mb-6 mt-4" data-id="element-206">
              Duerme o Te Devolvemos Todo
            </h3>
            <p className="text-lg mb-6 leading-relaxed" data-id="element-207">
              Aplica el sistema durante 30 días. Si después de aplicar
              consistentemente las estrategias de esta guía no ves ninguna
              mejora en el sueño de tu bebé — te devolvemos el 100% de tu
              inversión sin preguntas, sin formularios complicados y sin
              esperas.
            </p>
            <p className="text-lg font-medium text-azul-noche italic border-t border-gray-200 pt-6 mt-6" data-id="element-208">
              No porque pensemos que vas a pedirlo. Sino porque confiamos
              completamente en lo que esta guía puede hacer — y queremos que tú
              también confíes antes de decidir.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}